import { SearchHit } from 'models';

export const onlyLooseMatches = (hits: Partial<SearchHit<object>>[]) =>
    hits.length > 0 && hits.every((hit) => hit.match === 'fuzzy');
